import { useMsal } from '@azure/msal-react';
import Avatar from '../../DataDisplay/Avatar/Avatar.js';
import React__default, { useState, useRef } from 'react';
import '../../../styles/general.css.js';
import Typography from '../../DataDisplay/Typography/Typography.js';
import '../../Forms/Checkbox/Checkbox.js';
import '../../DataDisplay/Table/Table.module.scss.js';
import '../../../styles/forms.css.js';
import '../Tooltip/Tooltip.js';
import '../../Forms/ButtonIcon/ButtonIcon.module.css.js';
import 'react-intersection-observer';
import 'classnames';
import '../../../node_modules/lodash/_baseClone.js';
import '../../DataDisplay/TextTruncate/TextTruncate.module.css.js';
import Button from '../../Forms/Button/Button.js';
import 'bootstrap/dist/css/bootstrap.css';
import '../../Forms/Autocomplete/Autocomplete.js';
import '../../Forms/ButtonClose/ButtonClose.module.css.js';
import '@mui/x-date-pickers';
import '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs';
import '../../Forms/FloatingButton/FloatingButton.module.css.js';
import '../../Forms/Input/Input.js';
import '../../Forms/Radio/Radio.js';
import '../../Forms/Select/Select.js';
import '../../Forms/Slider/Slider.module.scss.js';
import '../../Forms/Textarea/Textarea.js';
import useClickOutside from '../../Hooks/useClickOutside/useClickOutside.js';
import 'copy-to-clipboard';
import '../../Hooks/useDateTimeFormat/useDateTimeFormat.js';
import 'use-debounce';
import '../../Hooks/useFromNow/useFromNow.js';
import 'crypto-js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-3LPAMF3R.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-LSZKOVGW.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-GTEBSQTL.js';
import 'react-router-dom';
import '../../Providers/LanguageProvider/LanguageProvider.js';
import useUserDetails from '../../Hooks/useUserDetails/useUserDetails.js';
import MenuOption from '../MenuOption/MenuOption.js';

/*
('https://apps.powerapps.com/play/e/default-254ba93e-1f6f-48f3-90e6-e2766664b477/a/05ff8d36-17ac-4a2e-8d12-e5f87802fbe5?hidenavbar=true&Lookup=32'); */
const Menu = ({ closeOnClickOutside = true, supportURL = '' }) => {
    const { name, username, gid } = useUserDetails();
    const [menuShown, setMenuShown] = useState(false);
    const { instance } = useMsal();
    const ref = useRef(null);
    useClickOutside(ref, () => setMenuShown(!menuShown), menuShown && closeOnClickOutside);
    return (React__default.createElement("div", { style: {
            position: 'relative',
            display: 'inline-block',
        } },
        React__default.createElement(Button, { type: "headless", onClick: () => setMenuShown(!menuShown) },
            React__default.createElement(Avatar, { altText: `${name.fullName}`, size: "small" })),
        React__default.createElement("div", { ref: ref, style: {
                position: 'absolute',
                textAlign: 'left',
                top: 40,
                right: 0,
                whiteSpace: 'nowrap',
                zIndex: 10,
                backgroundColor: '#FFFFFF',
                border: 'solid 1px #CCCCCC',
                borderRadius: 4,
                boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.15)',
                display: !menuShown ? 'none' : '',
            } },
            name.fullName && (React__default.createElement(MenuOption, { showPointer: false },
                React__default.createElement(Typography, { tag: "textextrasmall", color: "#666666" },
                    React__default.createElement("div", null, name.fullName),
                    React__default.createElement("div", null, username),
                    gid && React__default.createElement("div", null, gid)))),
            supportURL && (React__default.createElement(MenuOption, { onClick: () => window.open(supportURL) }, "Support")),
            React__default.createElement(MenuOption, { onClick: () => instance.logoutRedirect() }, "Logout"))));
};

export { Menu as default };
//# sourceMappingURL=Menu.js.map
